import { Box, Button, Typography } from "@mui/material";
import { useCallback } from "react";

import { Dialog } from "../../atoms/Dialog/Dialog";

// Translatable strings
const tCancel = "Cancel";
const tConfirmCancel = "Cancel Request";
const tConfirmMessage = "Are you sure you want to cancel your join request?";
const tDescription = "You can request to join again later if you change your mind.";

interface ConfirmCancelRequestDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemType: "room" | "event";
  itemName: string;
}

export const ConfirmCancelRequestDialog = ({
  open,
  onClose,
  onConfirm,
  itemType,
  itemName,
}: ConfirmCancelRequestDialogProps) => {
  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  return (
    <Dialog
      actions={
        <Box display="grid" gap="2rem" gridAutoColumns="minmax(0, 1fr)" gridAutoFlow="row" padding="1rem">
          <Typography variant="body1" gutterBottom data-testid="confirm-cancel-message">
            {tConfirmMessage}
          </Typography>

          <Box sx={{ bgcolor: "grey.50", borderRadius: 1, p: 2 }} data-testid="item-details">
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom data-testid="item-name">
              {itemName}
            </Typography>
            <Typography variant="body2" color="text.secondary" data-testid="item-type">
              {itemType === "room" ? "Room" : "Event"}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" data-testid="description-message">
            {tDescription}
          </Typography>

          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            <Button onClick={onClose} variant="outlined" data-testid="cancel-button">
              {tCancel}
            </Button>
            <Button onClick={handleConfirm} variant="contained" color="warning" data-testid="confirm-cancel-button">
              {tConfirmCancel}
            </Button>
          </Box>
        </Box>
      }
      dialogType="custom"
      maxWidth="sm"
      onDialogClose={onClose}
      open={open}
      title={tConfirmCancel}
    />
  );
};
